module.exports = __webpack_public_path__ + "static/media/Logo-Bloclit-v2.420d4167.png";